import React, { useState, useEffect, Fragment } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

//Rich editor
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//ICONS
import { BsFillCalendarWeekFill, BsFillExclamationTriangleFill, BsXLg } from "react-icons/bs";


//API
import donemler from '../../services/donemler';
import donemCreate from '../../services/donemCreate';
import donemUpdate from '../../services/donemUpdate';
import donemDelete from '../../services/donemDelete';

const DonemIslemleri = () => {

    let navigate = useNavigate();

    //Form Durum State 
    //false = yeni kayıt, true = düzenleme
    const [formDurum, setFormDurum] = useState(false)
    const [donemId, setDonemId] = useState(0)
    //MODAL State
    const [open, setOpen] = useState(false)

    //Form States
    const [donemName, setDonemName] = useState("")
    const [donemBasTar, setDonemBasTar] = useState("")
    const [donemBisTar, setDonemBisTar] = useState("")
    //Editör state
    const [donemAciklama, setDonemAciklama] = useState('');


    //Form Verilerini kontrol et
    const handleValidation = () => {
        if (donemName === "") {
            document.getElementById('donemName').focus()
            return toast.error("Dönem başlığı boş bırakılamaz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (donemBasTar === "") {
            document.getElementById('donemBasTar').focus()
            return toast.error("Dönem başlama tarihi boş bırakılamaz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (donemBisTar === "") {
            document.getElementById('donemBisTar').focus()
            return toast.error("Dönem bitiş tarihi boş bırakılamaz", {
                position: toast.POSITION.TOP_CENTER
            });
        }
        if (formDurum) {
            //Update
            handleDonemUpdate()
        } else {
            //Insert
            handleFormSave()
        }

    }

    //Formu Kaydet
    const handleFormSave = async () => {
        const data = {
            donemName: donemName,
            donemAciklama: donemAciklama,
            donemBasTar: donemBasTar,
            donemBisTar: donemBisTar,
            donemAktif: false,
            donemIsDelete: false
        }
        const result = await donemCreate(data)
        if (result) {
            toast.success("Dönem Eklendi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemler()
            clearForm()
        }
    }

    const handleDonemUpdate = async () => {
        const data = {
            donemId: donemId,
            donemName: donemName,
            donemAciklama: donemAciklama,
            donemBasTar: donemBasTar,
            donemBisTar: donemBisTar,
            donemAktif: false,
            donemIsDelete: false
        }
        const result = await donemUpdate(data)
        if (result) {
            toast.success("Dönem Güncellendi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemler()
            clearForm()
        }
    }

    const handleDurum = async (id,durum)=>{
        const data = {
            donemId: id,
            donemAktif: durum,
        }
        const result = await donemUpdate(data)
        if (result) {
            toast.success("Dönem Güncellendi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemler()
        }
    }

    const handleDonemDelete = async () => {
        const data = {
            donemId: donemId
        }
        const result = await donemDelete(data)
        if (result) {
            toast.success("Dönem silindi", {
                position: toast.POSITION.TOP_CENTER
            });
            getDonemler()
            clearForm()
        }

    }

    //Helper tarih çevir
    const tarihCevir = (tarih) => {
        const dateParts = tarih.split('-');
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];
        return `${year}-${month}-${day}`
    }

    //Güncellenecek donemi bilgileirni alma
    const getDonemData = (id) => {
        setFormDurum(true)
        const result = donemListesi.filter((item) => item.donemId === id)
        if (result.length > 0) {
            setDonemId(result[0].donemId)
            setDonemName(result[0].donemName)
            setDonemBasTar(tarihCevir(result[0].donemBasTarTRKisa))
            setDonemBisTar(tarihCevir(result[0].donemBisTarTRKisa))
            setDonemAciklama(result[0].donemAciklama)
        }
    }

    //Formu temizle
    const clearForm = () => {
        setFormDurum(false)
        setDonemName("")
        setDonemBasTar("")
        setDonemBisTar("")
        setDonemAciklama("")
        setDonemId(0)
        setOpen(false)
    }

    //Dönem Listesi
    const getDonemler = async () => {
        const result = await donemler()
        if(result.status===200){
            setDonemListesi(result.data)
        }else{
            navigate('/auth/login')  
        }
        
    }


    const [donemListesi, setDonemListesi] = useState([])
    useEffect(() => {
        document.title = "Dönem İşlemleri"
        getDonemler()
        //eslint-disable-next-line
    }, []);

    return (
        <main className='text-slate-500 text-sm'>
            <ToastContainer />
            <div className="py-5">
                <div className="w-full px-4 sm:px-6 md:px-8">
                    <div className='container mx-auto'>
                        <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500 '>Dönem İşlemleri</h1>
                    </div>

                    <div className='container mx-auto mb-6'>
                        <div className="bg-slate-100  w-full p-4 rounded-tl-lg rounded-lg flex flex-col gap-y-4">
                            <div className='flex items-center justify-between gap-x-4'>
                                <div className='flex-1 shrink-0 basis-0'>
                                    <input onChange={(e) => { setDonemName(e.target.value) }} value={donemName} id='donemName' type='text' placeholder='Dönem Başlık' className='w-full   text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div>
                                <div className='flex justify-between items-center space-x-3'>
                                    <button onClick={handleValidation} className='w-full text-xs h-10 text-white bg-slate-500   hover:bg-slate-500/80 leading-5 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                        {formDurum ? 'DÜZENLE' : 'KAYDET'}
                                    </button>
                                    <button onClick={clearForm} className='w-full text-xs h-10 text-slate-500 bg-slate-300 hover:bg-slate-300/80 leading-5 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                        İPTAL
                                    </button>
                                </div>
                            </div>
                            <div className='flex flex-col md:flex-row justify-between items-center gap-x-3 '>
                                <div className='w-full md:w-1/2'>
                                    <label className='text-sm text-slate-500'>Başlangıç Tarihi</label>
                                    <input onChange={(e) => { setDonemBasTar(e.target.value) }} value={donemBasTar} id='donemBasTar' type='date' className='w-full   text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div>
                                <div className='w-full md:w-1/2'>
                                    <label className='text-sm text-slate-500'>Biriş Tarihi</label>
                                    <input onChange={(e) => { setDonemBisTar(e.target.value) }} value={donemBisTar} id='donemBisTar' type='date' className='w-full   text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                </div>
                            </div>

                            <div className='relative pb-16 px-2 py-2 flex flex-col rounded overflow-y-auto bg-white scrollbar-thin scrollbar-track-slate-200 scrollbar-thumb-slate-300 hover:scrollbar-thumb-slate-400'>
                                <div className=''>
                                    <ReactQuill className='h-40' theme="snow" value={donemAciklama} onChange={setDonemAciklama} />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='container mx-auto'>
                        {/* min-h-[calc(100vh_-_200px)] */}
                        <div className="flex flex-wrap relative gap-y-2">
                            <div className="bg-white  w-full p-6 rounded-lg">
                                <div>
                                    <div>
                                        <div className='flex items-center gap-x-3 mb-4'>
                                            <BsFillCalendarWeekFill className='text-xl text-[#b09c73]' />
                                            <p>Dönem Listesi Listesi</p>
                                        </div>
                                        {
                                            donemListesi.length > 0 ? (
                                                <>
                                                    <div className='overflow-x-auto rounded-lg border '>
                                                        <table className='min-w-full  rounded divide-y divide-slate-600  overflow-y-auto'>
                                                            <thead className='border-b border-b-slate-300'>
                                                                <tr>
                                                                    <th className='px-4 py-2 text-left'>#</th>
                                                                    <th className='px-4 py-2 text-left'>Dönem Adı</th>
                                                                    <th className='px-4 py-2 text-left'>Başlangıç</th>
                                                                    <th className='px-4 py-2 text-left'>Bitiş</th>
                                                                    <th className='px-4 py-2 text-left'>Durum</th>
                                                                    <th className='px-4 py-2 text-left'>İşlemler</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="bg-white divide-y divide-slate-200  ">
                                                                {
                                                                    
                                                                    donemListesi && (
                                                                        donemListesi.map((item, key) => (
                                                                            <tr key={key}>
                                                                                <td className='px-4 py-2 text-sm font-medium whitespace-nowrap'>{item.donemId}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>{item.donemName}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>{item.donemBasTarTRKisa}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>{item.donemBisTarTRKisa}</td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap'>
                                                                                    {/* <input onChange={()=>handleDurum(item.donemId, !item.donemAktif)} type='checkbox' defaultChecked={item.donemAktif} /> */}
                                                                                    
                                                                                </td>
                                                                                <td className='px-4 py-2 text-sm whitespace-nowrap space-x-2'>
                                                                                    <button onClick={() => {
                                                                                        setOpen(true)
                                                                                        setDonemId(item.donemId)
                                                                                    }
                                                                                    }
                                                                                        className='text-xs h-8 text-white bg-red-500 border-transparent border hover:border-red-400 hover:bg-red-500/80 leading-3 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                                                        Sil
                                                                                    </button>
                                                                                    <button onClick={() => getDonemData(item.donemId)} className='text-xs h-8 text-white bg-slate-500 border-transparent border hover:border-slate-400 hover:bg-slate-500/80 leading-3 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                                        Düzenle
                                                                                    </button>
                                                                                    <button onClick={() => handleDurum(item.donemId, !item.donemAktif)} 
                                                                                        className={classNames({
                                                                                            'text-xs h-8 text-white  border-transparent border leading-3 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' : true,
                                                                                            'bg-green-500 hover:border-green-400 hover:bg-green-500/80' : item.donemAktif === true,
                                                                                            'bg-orange-500 hover:border-orange-400 hover:bg-orange-500/80' : item.donemAktif === false
                                                                                            })}>
                                                                                        {!item.donemAktif ? 'Aktif Yap' : 'Pasif Yap'}
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="mb-4 flex items-center gap-2">
                                                        <div className="bg-red-500 h-2 w-2 shrink-0 rounded-full"></div>
                                                        <h3 className="text-slate-500  font-sans text-sm">Kayıtlı Dönem Bulunmamaktadır.</h3>
                                                    </div>
                                                </>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* MODAL -------------------------------------------------- */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setOpen(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                UYARI!
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Dönemi silmek üzeresiniz. Emin misiniz?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            onClick={() => handleDonemDelete()}
                                        >
                                            Evet
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => setOpen(false)}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </main>



    );
}

export default DonemIslemleri;
